export function ajaxFunc(url, data, callback) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url,
      // type: 'POST',
      data: data,
      // data: data || null,
      // dataType: 'html',
      timeout: 60000, // Set your timeout value in milliseconds or 0 for unlimited
      success: (payLoad, textStatus, xhr) => {
        // console.info(data)
        if (callback) {
          callback(payLoad)
        }
        resolve()
      },
      error: (jqXHR, textStatus, errorThrown) => {
        if (textStatus === 'timeout') {
        }
        reject(errorThrown)
      }
    })
  })
}

export default ajaxFunc
